import {TimeSpan} from "@sparkware/app-utils";
import {useCallback, useRef, useState} from "react";
import {imagePreload} from "../../../../common/utils/image-preload";
import {Button} from "../../../basic-ui-components/button/base/button.component"
import {CheckboxInputBox} from "../../../basic-ui-components/form/checkboxinput.box";
import {Select} from "../../../basic-ui-components/form/select.component"
import {useServices} from "../../../react-hooks/use-services.hook";
import {FlexContainerBox} from "../../../themes/architecture/css-helpers/flex";
import {WheelOfJackpotbetDialogComponent} from "../../wheel-of-jackpotbet-dialog/wheel-of-jackpotbet-dialog.component";
import {ConfettiComponent} from "../../wheel-of-jackpotbet/confetti/confetti.component";
import {ConfettiZIndex} from "../../wheel-of-jackpotbet/confetti/confetti.component.interface";
import {WheelOfJackpotbetComponent} from "../../wheel-of-jackpotbet/wheel-of-jackpotbet.component";
import {WheelRefType} from "../../wheel-of-jackpotbet/wheel-of-jackpotbet.component.interface";
import {Label} from "../boxes/label";
import {ShowcaseConfigurationBox} from "../boxes/showcase-configuration/showcase-configuration.box"
import {ShowcaseContentContainerBox} from "../boxes/showcase-content-container/showcase-content-container.box"
import {WheelOfJackpotbetLogoBox} from "../../wheel-of-jackpotbet-dialog/boxes/wheel-of-jb-logo/wheel-of-jb-logo.box";

const wheelPrizes = ["SMALL", "MEDIUM", "BIG", "LARGE", "MEGA", "ULTRA"];

export const WheelOfJackpotbetShowcaseComponent: React.FC = () => {
    let [prizeWonIndex, setPrizeWonIndex] = useState<number | null>(0);
    let [toggleConfetti, setToggleConfetti] = useState(false);
    let toggleTimeout = useRef<number | null>(null);
    let [winningLights, setWinningLights] = useState(true);
    let [winningConfetti, setWinningConfetti] = useState(true);
    const services = useServices();

    const renderIconJustInPortraitAndPc = useCallback(() => {
        if (services.mediaQuery.landscape && services.mediaQuery.mAndBelow) {
            return null;
        }
        return <WheelOfJackpotbetLogoBox />
    }, [services.mediaQuery.landscape, services.mediaQuery.mAndBelow]);

    const openWheelOfJackpotbetDialog = useCallback(async () => {
        await Promise.allSettled([
            imagePreload(services.theme.currentTheme.assets.images.jackpot_bet.jackpot_bet_circle_svg.toString(), TimeSpan.fromSeconds(20)),
            imagePreload(services.theme.currentTheme.assets.images.wheel_of_jackpotbet.gold_center_png.toString(), TimeSpan.fromSeconds(20)),
            imagePreload(services.theme.currentTheme.assets.images.wheel_of_jackpotbet.flapper_png.toString(), TimeSpan.fromSeconds(20))
        ]);
        services.dialog.showModal((dialogHandler) => <div style={{position: "relative"}}>
            {renderIconJustInPortraitAndPc()}
            <WheelOfJackpotbetDialogComponent
                prizes={wheelPrizes}
                winAmount={1000}
                dialogHandler={dialogHandler}
                winningLights={winningLights}
                winningConfetti={winningConfetti}
                prizeIndex={prizeWonIndex === null ? Math.floor(Math.random() * wheelPrizes.length) : prizeWonIndex}
                onContinuePlaying={() => {}}
            />
        </div>
            , {
                hideBorders: true,
                hideDialogHeader: true,
                forceCentralization: true,
                disableFullscreenMobile: true,
                noDefaultContentPadding: true,
                forceTransparentBackground: true,
                forceTransparentContentBackground: true,
            });
    }, [services.dialog, winningLights, winningConfetti, prizeWonIndex, services.theme.currentTheme, renderIconJustInPortraitAndPc]);

    let wheelRef = useRef<WheelRefType>(null);
    return <ShowcaseContentContainerBox>
        <ShowcaseConfigurationBox style={{maxWidth: "300px"}}>
            <Button preset="secondary" onClick={openWheelOfJackpotbetDialog}>Open Dialog</Button>
            <Button preset="secondary" onClick={() => {
                if (toggleTimeout.current) {clearTimeout(toggleTimeout.current)}
                if (!toggleConfetti) {
                    toggleTimeout.current = window.setTimeout(() => {
                        setToggleConfetti(false);
                        toggleTimeout.current = null;
                    }, 5000);
                }
                setToggleConfetti(currentToggle => !currentToggle);
            }}>{toggleConfetti ? "Reset Confetti" : "Throw Confetti"}</Button>
            <Label>Prize result : </Label>
            <Select
                name={"wheel_prize"}
                id={"wheel_prize"}
                value={prizeWonIndex}
                onChange={(e) => {
                    const rawValue = e.target.options[e.target.selectedIndex].value;
                    const theValue = rawValue === "random" ? null : parseInt(rawValue);
                    setPrizeWonIndex(theValue);
                }}
                width="150px"
            >
                {wheelPrizes.map((p, idx) =>
                    <option key={idx} value={idx}>{p}</option>
                )}
                <option key={"random"} value={"random"}>Random</option>
            </Select>
            <FlexContainerBox>
                <CheckboxInputBox
                    id="winningLights" name="winningLights" value="true" checked={winningLights}
                    onChange={(e) => {
                        setWinningLights(e.target.checked);
                    }}
                /><Label htmlFor="winningLights">Winning Lights</Label>
            </FlexContainerBox>
            <FlexContainerBox>
                <CheckboxInputBox
                    id="winningConfetti" name="winningConfetti" value="true" checked={winningConfetti}
                    onChange={(e) => {
                        setWinningConfetti(e.target.checked);
                    }}
                /><Label htmlFor="winningConfetti">Winning Confetti</Label>
            </FlexContainerBox>
            <Button preset="primary" onClick={() => {
                if (wheelRef.current) {
                    wheelRef.current.spinTheWheel(prizeWonIndex === null ? Math.floor(Math.random() * wheelPrizes.length) : prizeWonIndex);
                }
            }}>Spin The Wheel</Button>
        </ShowcaseConfigurationBox>

        <ShowcaseConfigurationBox>
            <WheelOfJackpotbetComponent
                size={284}
                prizes={wheelPrizes}
                ref={wheelRef}
                winningLights={winningLights}
                winningConfetti={winningConfetti}
            />
            <ConfettiComponent animate={toggleConfetti} zIndex={ConfettiZIndex.AboveEverything} />
        </ShowcaseConfigurationBox>
    </ShowcaseContentContainerBox>
}